export const formatErpDocumentNumber = (numericPart, sucursalSede) => {
  const num =
    numericPart != null && numericPart !== "" ? String(numericPart).trim() : "";
  const abbr = sucursalSede?.abbreviation
    ? String(sucursalSede.abbreviation).trim()
    : "";
  const seriesRaw = sucursalSede?.seriesCharacter;
  const series =
    seriesRaw != null && String(seriesRaw).trim() !== ""
      ? String(seriesRaw).trim().charAt(0)
      : "";

  if (series) {
    return num ? `${num}-${series}` : series;
  }
  if (abbr) {
    return num ? `${num}-${abbr}` : abbr;
  }
  return num || "—";
};

export default formatErpDocumentNumber;
